/* eslint-disable */
import { useState, useEffect, Fragment } from 'react';
import { pengadaanAPI, proyekAPI, gudangAPI, masterAPI } from '../services/api';
import { usePR, usePO, useDPH } from '../services/usePengadaan';
import { LoadingSpinner, ErrorBox, EmptyState } from '../components/LoadingSpinner';
import { useRef } from 'react';
import BtnExportPDF from '../components/BtnExportPDF';


function useProyekListP() {
  const [list, setList] = useState([]);
  useEffect(() => {
    proyekAPI.getAll().then(r => {
      if (r.ok) {
        const sorted = r.data.data
          .map(p => ({ id: p.id, kode: p.kode, nama: p.nama }))
          .sort((a,b) => a.kode.localeCompare(b.kode, 'id', { numeric:true }));
        setList(sorted);
      }
    }).catch(()=>{});
  }, []);
  return list;
}

function useMaterialListP() {
  const [list, setList] = useState([]);
  useEffect(() => {
    gudangAPI.getAllBarang().then(r => {
      if (r.ok) {
        const sorted = r.data.data
          .map(b => ({ id: b.id, kode: b.kode, nama: b.nama, satuan: b.satuan }))
          .sort((a,b) => a.nama.localeCompare(b.nama, 'id'));
        setList(sorted);
      }
    }).catch(()=>{});
  }, []);
  return list;
}

function useVendorListP() {
  const [list, setList] = useState([]);
  useEffect(() => {
    masterAPI.getAllVendor().then(r => {
      if (r.ok) {
        const sorted = r.data.data
          .map(v => ({ id: v.id, kode: v.kode, nama: v.nama }))
          .sort((a,b) => a.nama.localeCompare(b.nama, 'id'));
        setList(sorted);
      }
    }).catch(()=>{});
  }, []);
  return list;
}

const dataVendorList = [
  { id: 'VND-001', nama: 'PT Semen Indonesia'      },
  { id: 'VND-002', nama: 'CV Baja Utama'           },
  { id: 'VND-003', nama: 'PT Beton Jaya'           },
  { id: 'VND-004', nama: 'UD Material Sejahtera'   },
  { id: 'VND-005', nama: 'PT Cat & Finishing Indo' },
];

const initPR = [
  { id:'PR-2025-001', tgl:'2025-07-01', proyek:'Gedung Kantor Surabaya', departemen:'Logistik', lokasi:'Surabaya', material:'Semen Portland', qty:500, satuan:'sak', status:'approved', diajukan:'Budi S.',  items:[{nama:'Semen Portland',spesifikasi:'Type I',jumlah:'500',satuan:'sak',keterangan:'Struktur lantai 3',estHarga:'75000'}] },
  { id:'PR-2025-002', tgl:'2025-07-02', proyek:'Renovasi RSUD Sidoarjo', departemen:'Proyek',   lokasi:'Sidoarjo', material:'Besi Beton D13',  qty:200, satuan:'btg', status:'pending',  diajukan:'Rina W.', items:[{nama:'Besi Beton D13',spesifikasi:'SNI',jumlah:'200',satuan:'btg',keterangan:'Tulangan kolom',estHarga:'140000'}] },
  { id:'PR-2025-003', tgl:'2025-07-03', proyek:'Jalan Lingkar Gresik',   departemen:'Proyek',   lokasi:'Gresik',   material:'Ready Mix K300',  qty:50,  satuan:'m³', status:'pending',  diajukan:'Dodi P.', items:[{nama:'Ready Mix K300',spesifikasi:'K300',jumlah:'50',satuan:'m³',keterangan:'Cor jalan',estHarga:'1250000'}] },
  { id:'PR-2025-004', tgl:'2025-07-03', proyek:'Tower Apartemen Malang', departemen:'HSE',      lokasi:'Malang',   material:'Pasir Beton',     qty:30,  satuan:'m³', status:'draft',    diajukan:'Sari A.', items:[{nama:'Pasir Beton',spesifikasi:'Halus',jumlah:'30',satuan:'m³',keterangan:'Pondasi',estHarga:'300000'}] },
];

const initPO = [
  { id:'PO-2025-001', tgl:'2025-07-01', idPR:'PR-2025-001', proyek:'Gedung Kantor Surabaya', vendor:'PT Semen Indonesia',   material:'Semen Portland 500 sak', nilai:37500000, status:'approved', tglKirim:'2025-07-05', approvalLogistik:'✅', approvalManajer:'✅', approvalDirektur:'✅' },
  { id:'PO-2025-002', tgl:'2025-07-02', idPR:'PR-2025-002', proyek:'Renovasi RSUD Sidoarjo', vendor:'CV Baja Utama',        material:'Besi Beton D13 200 btg', nilai:28000000, status:'direktur', tglKirim:'2025-07-08', approvalLogistik:'✅', approvalManajer:'✅', approvalDirektur:'⏳' },
  { id:'PO-2025-003', tgl:'2025-07-03', idPR:'PR-2025-003', proyek:'Jalan Lingkar Gresik',   vendor:'PT Beton Jaya',        material:'Ready Mix K300 50 m³',   nilai:62500000, status:'manajer',  tglKirim:'2025-07-10', approvalLogistik:'✅', approvalManajer:'⏳', approvalDirektur:'⏳' },
  { id:'PO-2025-004', tgl:'2025-07-03', idPR:'',            proyek:'Tower Apartemen Malang',  vendor:'UD Material Sejahtera',material:'Pasir Beton 30 m³',      nilai:9000000,  status:'draft',    tglKirim:'2025-07-12', approvalLogistik:'⏳', approvalManajer:'⏳', approvalDirektur:'⏳' },
];

const initGR = [
  { id:'GR-2025-001', tgl:'2025-07-05', idPO:'PO-2025-001', vendor:'PT Semen Indonesia', material:'Semen Portland', satuan:'sak', qtyPO:500, qtyTerima:500, kondisi:'Baik',           keterangan:'Sesuai PO',          diterima:'Gudang' },
  { id:'GR-2025-002', tgl:'2025-07-06', idPO:'PO-2025-001', vendor:'PT Semen Indonesia', material:'Semen Portland', satuan:'sak', qtyPO:500, qtyTerima:498, kondisi:'Ada yang rusak',  keterangan:'2 sak sobek, retur', diterima:'Gudang' },
];

function formatRp(n) { return 'Rp ' + Number(n).toLocaleString('id-ID'); }
function formatTanggalIndo(value) {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
}
function tglHariIni() { return new Date().toISOString().split('T')[0]; }
function generateId(prefix, list) {
  const tahun = new Date().getFullYear();
  const urut  = String(list.length + 1).padStart(3, '0');
  return `${prefix}-${tahun}-${urut}`;
}

const inputStyle = {
  padding: '8px 10px', border: '1.5px solid #ddd', borderRadius: '8px',
  fontSize: '13px', color: '#333', background: '#fafafa',
  outline: 'none', width: '100%', fontFamily: 'inherit', boxSizing: 'border-box'
};

const row2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' };

function Badge({ status }) {
  const map = {
    draft:    { label:'Draft',             bg:'#f0f4f8', color:'#666'    },
    pending:  { label:'Menunggu Approval', bg:'#fef5e7', color:'#e67e22' },
    approved: { label:'Disetujui',         bg:'#eafaf1', color:'#27ae60' },
    rejected: { label:'Ditolak',           bg:'#fdedec', color:'#e74c3c' },
    logistik: { label:'Menunggu Logistik', bg:'#fef5e7', color:'#e67e22' },
    manajer:  { label:'Menunggu Manajer',  bg:'#eaf0fb', color:'#2980b9' },
    direktur: { label:'Menunggu Direktur', bg:'#f3e5f5', color:'#8e44ad' },
    tinggi:   { label:'🔴 Tinggi',         bg:'#fdedec', color:'#e74c3c' },
    normal:   { label:'🟡 Normal',         bg:'#fef5e7', color:'#e67e22' },
    rendah:   { label:'🟢 Rendah',         bg:'#eafaf1', color:'#27ae60' },
    'Baik':             { label:'✅ Baik',          bg:'#eafaf1', color:'#27ae60' },
    'Ada yang rusak':   { label:'⚠️ Rusak',         bg:'#fef5e7', color:'#e67e22' },
  };
  const s = map[status] || { label: status, bg: '#f0f4f8', color: '#666' };
  return (
    <span style={{ display:'inline-block', padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:s.bg, color:s.color, whiteSpace:'nowrap' }}>
      {s.label}
    </span>
  );
}

function Modal({ show, onClose, title, children, footer, width }) {
  if (!show) return null;
  return (
    <div className="erp-modal-overlay" style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:999, padding:'20px' }}>
      <div className="erp-modal-box" style={{ background:'white', borderRadius:'16px', width:'100%', maxWidth: width || '700px', maxHeight:'95vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 24px', borderBottom:'1px solid #f0f4f8', gap:'12px' }}>
          <h3 style={{ fontSize:'15px', color:'#1a3a5c', margin:0, wordBreak:'break-word' }}>{title}</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#888', flexShrink:0 }}>✕</button>
        </div>
        <div className="erp-modal-body" style={{ padding:'20px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'12px' }}>
          {children}
        </div>
        {footer && (
          <div className="erp-modal-footer" style={{ padding:'14px 20px', borderTop:'1px solid #f0f4f8', display:'flex', justifyContent:'flex-end', gap:'10px' }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

function KopFormulir({ judulFormulir, rows }) {
  const totalRows = rows.length; // biasanya 3: No.Dok, Revisi, Tgl Terbit

  return (
    <div className="kop-formulir-erp" style={{
      display:'grid',
      gridTemplateColumns:'80px 1.6fr 90px 1fr',
      gridTemplateRows: `repeat(${totalRows}, auto)`,
      border:'1.5px solid #000',
      fontFamily:'inherit', color:'#000', background:'white'
    }}>

      {/* LOGO — span semua baris */}
      <div style={{
        gridColumn:'1', gridRow:`1 / ${totalRows+1}`,
        borderRight:'1.5px solid #000',
        display:'flex', alignItems:'center', justifyContent:'center', padding:'4px'
      }}>
        <img src={`${process.env.PUBLIC_URL}/kop mkmj.jpg`} alt="Logo PT Mitra Karya Mandiri Jaya"
          style={{ width:'100%', height:'100%', objectFit:'contain' }} />
      </div>

      {/* NAMA PT — baris 1 saja */}
      <div style={{
        gridColumn:'2', gridRow:'1',
        borderRight:'1.5px solid #000', borderBottom:'1.5px solid #000',
        padding:'6px 12px', textAlign:'center',
        display:'flex', alignItems:'center', justifyContent:'center'
      }}>
        <span style={{ fontWeight:'700', fontSize:'13px' }}>PT. MITRA KARYA MANDIRI JAYA</span>
      </div>

      {/* JUDUL FORMULIR — span sisa baris */}
      <div style={{
        gridColumn:'2', gridRow:`2 / ${totalRows+1}`,
        borderRight:'1.5px solid #000',
        display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'2px',
        padding:'6px 12px', textAlign:'center'
      }}>
        <div style={{ fontWeight:'700', fontSize:'13px' }}>FORMULIR</div>
        <div style={{ fontWeight:'700', fontSize:'13px', textTransform:'uppercase' }}>{judulFormulir}</div>
      </div>

      {/* KOLOM LABEL + VALUE — setiap baris satu item */}
      {rows.map(([label, value], i) => (
        <Fragment key={label || i}>
          <div key={`l-${label}`} style={{
            gridColumn:'3', gridRow: i+1,
            borderRight:'1px solid #000',
            borderBottom: i < totalRows-1 ? '1.5px solid #000' : 'none',
            padding:'4px 6px', fontSize:'11px',
            display:'flex', alignItems:'center'
          }}>
            {label}
          </div>
          <div key={`v-${label}`} style={{
            gridColumn:'4', gridRow: i+1,
            borderBottom: i < totalRows-1 ? '1.5px solid #000' : 'none',
            padding:'4px 6px', fontSize:'11px',
            display:'flex', alignItems:'center'
          }}>
            : {value}
          </div>
        </Fragment>
      ))}

    </div>
  );
}

function FormGroup({ label, required, children }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'5px' }}>
      <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>
        {label} {required && <span style={{ color:'#e74c3c' }}>*</span>}
      </label>
      {children}
    </div>
  );
}

function Btn({ onClick, color='biru', children, disabled }) {
  const colors = {
    biru:  { bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', txt:'white'            },
    hijau: { bg:'linear-gradient(135deg,#1e8449,#27ae60)',  txt:'white'            },
    merah: { bg:'linear-gradient(135deg,#c0392b,#e74c3c)',  txt:'white'            },
    abu:   { bg:'white', txt:'#333', border:'1.5px solid #ddd'                     },
  };
  const c = colors[color];
  return (
    <button onClick={onClick} disabled={disabled} style={{ padding:'9px 16px', background:c.bg, color:c.txt, border:c.border||'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.6:1, whiteSpace:'nowrap' }}>
      {children}
    </button>
  );
}

function DatePickerField({ name, value, onChange, readOnly, style }) {
  return (
    <input
      name={name}
      value={value || ''}
      onChange={onChange}
      readOnly={readOnly}
      type="date"
      style={{ ...inputStyle, ...(style || {}), minHeight:'36px' }}
    />
  );
}

function ApprovalTrack({ logistik, manajer, direktur }) {
  const steps = [
    { label:'Logistik',       val: logistik },
    { label:'Manajer Proyek', val: manajer  },
    { label:'Direktur',       val: direktur },
  ];
  return (
    <div style={{ background:'#f8fbff', borderRadius:'10px', padding:'14px', border:'1px solid #e0e8f4' }}>
      <p style={{ fontSize:'12px', fontWeight:'700', color:'#1a3a5c', marginBottom:'12px', marginTop:0 }}>Alur Approval 3 Level</p>
      <div style={{ display:'flex', alignItems:'center' }}>
        {steps.map((s, i) => {
          const ok  = s.val === '✅';
          const no  = s.val === '❌';
          const bg  = ok ? '#27ae60' : no ? '#e74c3c' : '#ddd';
          const txt = (ok || no) ? 'white' : '#888';
          return (
            <div key={i} style={{ display:'flex', alignItems:'center', flex:1 }}>
              {i > 0 && <div style={{ height:'2px', background:'#ddd', flex:1 }} />}
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'4px' }}>
                <div style={{ width:'30px', height:'30px', borderRadius:'50%', background:bg, color:txt, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'700', fontSize:'13px' }}>{i+1}</div>
                <span style={{ fontSize:'11px', fontWeight:'600', color:'#333' }}>{s.label}</span>
                <span style={{ fontSize:'11px', color: ok?'#27ae60': no?'#e74c3c':'#aaa' }}>{ok?'Disetujui': no?'Ditolak':'Menunggu'}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function SelectProyek({ value, onChange, list, placeholder = '-- Pilih Proyek --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const wrapRef = useRef(null);

  const selected = list.find(p => String(p.id) === String(value));
  const filtered = list.filter(p =>
    !search ||
    p.nama.toLowerCase().includes(search.toLowerCase()) ||
    p.kode.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={wrapRef} style={{ position:'relative' }}>
      <div
        onClick={() => setOpen(!open)}
        style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center' }}
      >
        <span style={{ color: selected?'#333':'#aaa', fontSize:'13px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {selected ? `${selected.kode} · ${selected.nama}` : placeholder}
        </span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>

      {open && (
        <div style={{
          position:'absolute', top:'100%', left:0, right:0, marginTop:'4px',
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.15)', zIndex:1000,
          maxHeight:'280px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input
              autoFocus
              value={search}
              onChange={e=>setSearch(e.target.value)}
              placeholder="🔍 Ketik kode atau nama proyek..."
              style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }}
            />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            <div
              onClick={() => { onChange(''); setOpen(false); setSearch(''); }}
              style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', color:'#aaa' }}
              onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
              onMouseLeave={e=>e.currentTarget.style.background='white'}
            >
              -- Kosongkan --
            </div>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : (
              filtered.map(p => (
                <div
                  key={p.id}
                  onClick={() => { onChange(String(p.id)); setOpen(false); setSearch(''); }}
                  style={{
                    padding:'8px 12px', fontSize:'12px', cursor:'pointer',
                    background: String(p.id)===String(value) ? '#eaf0fb' : 'white',
                    fontWeight: String(p.id)===String(value) ? '600' : '400',
                  }}
                  onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                  onMouseLeave={e=>e.currentTarget.style.background = String(p.id)===String(value) ? '#eaf0fb' : 'white'}
                >
                  <strong>{p.kode}</strong> · {p.nama}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function SelectMaterial({ value, onChange, list, onPilihItem, placeholder = '-- Pilih Material --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const [pos, setPos]       = useState({ top:0, left:0, width:0 });
  const triggerRef = useRef(null);
  const dropRef    = useRef(null);

  const filtered = list.filter(m =>
    !search ||
    m.nama.toLowerCase().includes(search.toLowerCase()) ||
    (m.kode||'').toLowerCase().includes(search.toLowerCase())
  );

  function bukaDropdown() {
    if (triggerRef.current) {
      const r = triggerRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left, width: r.width });
    }
    setOpen(true);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropRef.current?.contains(e.target)) return;
      setOpen(false); setSearch('');
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <div ref={triggerRef} onClick={bukaDropdown} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', padding:'5px 8px', fontSize:'12px' }}>
        <span style={{ color: value?'#333':'#aaa', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {value || placeholder}
        </span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>

      {open && (
        <div ref={dropRef} style={{
          position:'fixed', top: pos.top, left: pos.left, width: pos.width,
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)', zIndex:2000,
          maxHeight:'260px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik nama atau kode material..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : filtered.map(m => (
              <div key={m.id}
                onClick={() => { onChange(m.nama); if(onPilihItem) onPilihItem(m); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: m.nama===value?'#eaf0fb':'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = m.nama===value?'#eaf0fb':'white'}
              >
                <strong>{m.nama}</strong>{m.satuan && <span style={{ color:'#888' }}> · {m.satuan}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

function SelectSupplier({ value, onChange, list, placeholder = '-- Pilih Supplier --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const [pos, setPos]       = useState({ top:0, left:0, width:0 });
  const triggerRef = useRef(null);
  const dropRef    = useRef(null);

  const filtered = list.filter(v =>
    !search ||
    v.nama.toLowerCase().includes(search.toLowerCase()) ||
    (v.kode||'').toLowerCase().includes(search.toLowerCase())
  );

  function bukaDropdown() {
    if (triggerRef.current) {
      const r = triggerRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left, width: r.width });
    }
    setOpen(true);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropRef.current?.contains(e.target)) return;
      setOpen(false); setSearch('');
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <div ref={triggerRef} onClick={bukaDropdown} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', padding:'5px 8px', fontSize:'12px' }}>
        <span style={{ color: value?'#333':'#aaa', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {value || placeholder}
        </span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>

      {open && (
        <div ref={dropRef} style={{
          position:'fixed', top: pos.top, left: pos.left, width: pos.width,
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)', zIndex:2000,
          maxHeight:'240px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik nama atau kode supplier..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : filtered.map(v => (
              <div key={v.id}
                onClick={() => { onChange(v.nama); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: v.nama===value?'#eaf0fb':'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = v.nama===value?'#eaf0fb':'white'}
              >
                <strong>{v.nama}</strong>{v.kode && <span style={{ color:'#888' }}> · {v.kode}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

// ============================================
// TAB PR — Form seperti formulir fisik
// ============================================
function TabPR({ user }) {
  const detailRef = useRef(null); 
  const dataProyekList = useProyekListP();
  const dataMaterialList = useMaterialListP();
  const [filter, setFilter]         = useState('');
  const { data: listPR, loading, error, refetch } = usePR(filter);
  const [showForm, setShowForm]     = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [editingPR, setEditingPR]   = useState(null);

  const itemKosong = { nama:'', spesifikasi:'', jumlah:'', satuan:'', keterangan:'', cek:'' };
  const formKosong = {
    proyek_id:'', departemen:'', lokasi:'', keperluan:'', tgl_butuh:'',
    namaBarang:'',
    items:[ { ...itemKosong } ]
  };
  const [form, setForm] = useState(formKosong);

  function handleChange(e) { setForm({ ...form, [e.target.name]: e.target.value }); }
  function updateItem(idx,field,value) {
    setForm(prev => ({ ...prev, items: prev.items.map((it,i)=>i===idx?{...it,[field]:value}:it) }));
  }
  function tambahItem() { setForm({ ...form, items:[...form.items,{...itemKosong}] }); }
  function hapusItem(idx) { setForm({ ...form, items: form.items.filter((_,i)=>i!==idx) }); }

  function bisaDiubah(pr) {
    return pr.dibuat_oleh === user?.id && ['draft','pending'].includes(pr.status);
  }

  function bukaForm() {
    setEditingPR(null);
    setForm(formKosong);
    setShowForm(true);
  }

  function bukaEdit(pr) {
    setEditingPR(pr);
    setForm({
      proyek_id:  String(pr.proyek_id || ''),
      departemen: pr.departemen || '',
      lokasi:     pr.lokasi || '',
      keperluan:  pr.keperluan || '',
      tgl_butuh:  pr.tgl_butuh ? pr.tgl_butuh.split('T')[0] : '',
      namaBarang: pr.nama_barang || '',
      items: (pr.items && pr.items.length > 0)
        ? pr.items.map(it => ({ nama:it.nama||'', spesifikasi:it.spesifikasi||'', jumlah:it.jumlah||'', satuan:it.satuan||'', keterangan:it.keterangan||'', cek:it.cek||'' }))
        : [ { ...itemKosong } ],
    });
    setShowForm(true);
  }

  async function hapusPR(pr) {
    if (!window.confirm(`Hapus PRB ${pr.no_pr}? Tindakan ini tidak bisa dibatalkan.`)) return;
    try {
      const result = await pengadaanAPI.deletePR(pr.id);
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        refetch();
      } else {
        alert(`❌ ${result.data.message}`);
      }
    } catch (err) {
      alert('❌ Gagal terhubung ke server');
    }
  }

  async function submitPR(status) {
    if (!form.proyek_id || !form.items[0].nama) {
      alert('⚠️ Proyek dan nama barang wajib diisi!'); return;
    }
    setSubmitting(true);
    try {
      const payload = {
        proyek_id:   Number(form.proyek_id),
        departemen:  form.departemen,
        lokasi:      form.lokasi,
        nama_barang: form.namaBarang || form.items[0].nama,
        keperluan:   form.keperluan,
        tgl_butuh:   form.tgl_butuh || null,
        items:       form.items.filter(i => i.nama),
      };

      const result = editingPR
        ? await pengadaanAPI.updatePR(editingPR.id, payload)
        : await pengadaanAPI.createPR(payload);

      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setEditingPR(null);
        setForm(formKosong);
        refetch();
      } else {
        alert(`❌ ${result.data.message}`);
      }
    } catch (err) {
      alert('❌ Gagal terhubung ke server');
    } finally {
      setSubmitting(false);
    }
  }

  async function prosesApproval(id, aksi) {
    if (!window.confirm(`${aksi==='approve'?'✅ Setujui':'❌ Tolak'} PR ini?`)) return;
    try {
      const result = await pengadaanAPI.approvePR(id, aksi);
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowDetail(null);
        refetch();
      } else {
        alert(`❌ ${result.data.message}`);
      }
    } catch (err) {
      alert('❌ Gagal terhubung ke server');
    }
  }

  const thS = { padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8', whiteSpace:'nowrap' };
  const tdS = { border:'1px solid #ddd', padding:'5px 8px', fontSize:'12px', verticalAlign:'middle' };
  const inC = { ...inputStyle, padding:'5px 7px', fontSize:'12px', border:'none', background:'transparent', width:'100%' };

  return (
    <div>
      {/* TOOLBAR */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px', gap:'10px' }}>
        <select value={filter} onChange={e=>setFilter(e.target.value)} style={{ ...inputStyle, maxWidth:'200px' }}>
          <option value="">Semua Status</option>
          <option value="draft">Draft</option>
          <option value="pending">Menunggu Approval</option>
          <option value="approved">Disetujui</option>
          <option value="rejected">Ditolak</option>
        </select>
        <Btn onClick={bukaForm}>+ Buat PPB Baru</Btn>
      </div>

      {/* STATE */}
      {loading && <LoadingSpinner pesan="Memuat data PPB dari database..." />}
      {error   && <ErrorBox pesan={error} onRetry={refetch} />}

      {/* TABEL */}
      {!loading && !error && (
        <div style={{ overflowX:'auto' }}>
          {listPR.length === 0 ? (
            <EmptyState icon="📋" judul="Belum ada PPB" sub="Klik '+ Buat PPB Baru' untuk membuat permintaan pembelian" />
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                  {['No. PPB','Tgl','Proyek','Dept','Material & Qty','Status','Diajukan','Aksi'].map(h=>(
                    <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'8px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {listPR.map(pr=>(
                  <tr key={pr.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                    <td style={{ padding:'12px', fontSize:'13px' }}><strong>{pr.no_pr}</strong></td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{pr.created_at?.split('T')[0]}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{pr.nama_proyek}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{pr.departemen}</td>

                    {/* KOLOM MATERIAL & QTY — tampilkan semua items */}
                    <td style={{ padding:'12px', fontSize:'12px' }}>
                      {pr.items && pr.items.length > 0 ? (
                        <div style={{ display:'flex', flexDirection:'column', gap:'4px' }}>
                          {pr.items.map((item, i) => (
                            <div key={i} style={{ display:'flex', gap:'6px', alignItems:'center' }}>
                              <span style={{ background:'#eaf0fb', color:'#2d6a9f', padding:'1px 6px', borderRadius:'4px', fontSize:'10px', fontWeight:'700', whiteSpace:'nowrap' }}>
                                {i+1}
                              </span>
                              <span style={{ fontWeight:'500' }}>{item.nama}</span>
                              <span style={{ color:'#888', whiteSpace:'nowrap' }}>
                                {item.jumlah} {item.satuan}
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span style={{ color:'#aaa' }}>{pr.nama_barang || '-'}</span>
                      )}
                    </td>
                    <td style={{ padding:'12px' }}><Badge status={pr.status} /></td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{pr.nama_pengaju}</td>
                    <td style={{ padding:'12px' }}>
                      <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
                        <button onClick={()=>setShowDetail(pr)} style={{ padding:'5px 12px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                          Detail
                        </button>
                        {bisaDiubah(pr) && <>
                          <button onClick={()=>bukaEdit(pr)} style={{ padding:'5px 12px', background:'#fff6e0', color:'#b7791f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                            Edit
                          </button>
                          <button onClick={()=>hapusPR(pr)} style={{ padding:'5px 12px', background:'#fdedec', color:'#e74c3c', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                            Hapus
                          </button>
                        </>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* MODAL FORM PPB */}
      <Modal
        show={showForm}
        onClose={()=>{ setShowForm(false); setEditingPR(null); }}
        title={editingPR ? `✏️ Revisi PPB — ${editingPR.no_pr}` : "📋 Permintaan Pembelian Barang (PPB)"}
        footer={<>
          <Btn color="abu" onClick={()=>{ setShowForm(false); setEditingPR(null); }} disabled={submitting}>Batal</Btn>
          {editingPR ? (
            <Btn onClick={()=>submitPR()} disabled={submitting}>
              {submitting ? '⏳ Menyimpan...' : '💾 Simpan Perubahan'}
            </Btn>
          ) : <>
            <Btn color="abu" onClick={()=>submitPR('draft')} disabled={submitting}>
              {submitting ? '⏳...' : '💾 Simpan Draft'}
            </Btn>
            <Btn onClick={()=>submitPR('pending')} disabled={submitting}>
              {submitting ? '⏳ Menyimpan...' : '📤 Ajukan'}
            </Btn>
          </>}
        </>}
      >
        <div style={{ border:'2px solid #1a3a5c', borderRadius:'8px', overflow:'auto', fontSize:'12px' }}>

          {/* KOP */}
          <KopFormulir
            judulFormulir="Permintaan Pembelian Barang (PPB)"
            rows={[
              ['No. Dok', 'MKMJ/FM/PUR/01-01'],
              ['Revisi', '01'],
              ['Tgl. Terbit', '01 Juni 2026'],
            ]}
          />

          {/* INFO HEADER */}
          <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
            {[
              { label:'Departemen', name:'departemen', placeholder:'Logistik / Proyek / HSE' },
              { label:'Lokasi',     name:'lokasi',     placeholder:'Lokasi proyek'           },
            ].map(f=>(
              <div key={f.name} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                <span style={{ fontSize:'12px', fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'100px' }}>{f.label}</span>
                <span>:</span>
                <input name={f.name} value={form[f.name]} onChange={handleChange}
                  placeholder={f.placeholder} style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px', flex:1 }} />
              </div>
            ))}
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontSize:'12px', fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'100px' }}>Proyek</span>
              <span>:</span>
              <div style={{ flex:1 }}>
                <SelectProyek
                  value={form.proyek_id}
                  onChange={(val)=>setForm({...form, proyek_id: val})}
                  list={dataProyekList}
                />
              </div>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontSize:'12px', fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'100px' }}>Tgl Butuh</span>
              <span>:</span>
              <input type="date" name="tgl_butuh" value={form.tgl_butuh} onChange={handleChange}
                style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px', flex:1 }} />
            </div>
          </div>

          {/* TABEL ITEM */}
          <div style={{ overflowX:'auto', overflowY:'auto', maxHeight:'240px' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:'580px' }}>
              <thead style={{ position:'sticky', top:0, zIndex:1 }}>
                <tr style={{ background:'#f0f4f8' }}>
                  {['No.','Nama Barang','Spesifikasi','Jumlah','Satuan','Keterangan','Cek ok/tdk ok',''].map((h,i)=>(
                    <th key={i} style={{ padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', whiteSpace:'nowrap', background:'#f0f4f8' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {form.items.map((item,idx)=>(
                  <tr key={idx}>
                    <td style={{ ...tdS, textAlign:'center', fontWeight:'700', color:'#666', width:'32px' }}>{idx+1}</td>
                    <td style={{ border:'1px solid #ddd', padding:'4px' }}>
                      <SelectMaterial
                        value={item.nama}
                        onChange={(nilai)=>updateItem(idx,'nama',nilai)}
                        onPilihItem={(m)=>updateItem(idx,'satuan', m.satuan || item.satuan)}
                        list={dataMaterialList}
                      />
                    </td>
                    <td style={{ border:'1px solid #ddd', padding:'4px' }}><input value={item.spesifikasi} onChange={e=>updateItem(idx,'spesifikasi',e.target.value)} placeholder="Spesifikasi" style={inC} /></td>
                    <td style={{ border:'1px solid #ddd', padding:'4px', width:'70px' }}><input type="number" value={item.jumlah} onChange={e=>updateItem(idx,'jumlah',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'center' }} /></td>
                    <td style={{ border:'1px solid #ddd', padding:'4px', width:'80px' }}><input value={item.satuan} onChange={e=>updateItem(idx,'satuan',e.target.value)} placeholder="sak/m³" style={{ ...inC, textAlign:'center' }} /></td>
                    <td style={{ border:'1px solid #ddd', padding:'4px' }}><input value={item.keterangan} onChange={e=>updateItem(idx,'keterangan',e.target.value)} placeholder="Keterangan" style={inC} /></td>
                    <td style={{ border:'1px solid #ddd', padding:'4px', width:'110px', textAlign:'center' }}>
                      <select value={item.cek||''} onChange={e=>updateItem(idx,'cek',e.target.value)}
                        style={{ ...inC, cursor:'pointer', fontWeight:'600', color: item.cek==='ok'?'#27ae60': item.cek==='tidakOk'?'#e74c3c':'#888' }}>
                        <option value="">— Pilih —</option>
                        <option value="ok">✅ OK</option>
                        <option value="tidakOk">❌ Tidak OK</option>
                      </select>
                    </td>
                    <td style={{ border:'1px solid #ddd', padding:'4px', width:'32px', textAlign:'center' }}>
                      {form.items.length>1 && <button onClick={()=>hapusItem(idx)} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'14px', opacity:0.5 }}>🗑️</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* TAMBAH BARIS */}
          <div style={{ padding:'8px 12px', borderTop:'1px solid #ddd', background:'#fafcff', borderBottom:'1px solid #ddd' }}>
            <button onClick={tambahItem} style={{ padding:'5px 14px', background:'white', border:'1.5px dashed #2d6a9f', borderRadius:'6px', fontSize:'12px', color:'#2d6a9f', cursor:'pointer', fontWeight:'600' }}>
              + Tambah Baris
            </button>
          </div>

          {/* TANDA TANGAN */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr' }}>
            {[
              { judul:'Diajukan Oleh,',  nama: user?.nama||'................................', jabatan: user?.role||'Jabatan' },
              { judul:'Diperiksa Oleh,', nama:'................................', jabatan:'Manajer Proyek' },
              { judul:'Disetujui Oleh,', nama:'................................', jabatan:'Direktur'       },
            ].map((ttd,i)=>(
              <div key={i} style={{ padding:'12px 16px', borderRight: i<2?'1px solid #ddd':'none' }}>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'48px' }}>{ttd.judul}</div>
                <div style={{ borderTop:'1px solid #333', paddingTop:'4px' }}>
                  <div style={{ fontSize:'11px', color:'#555' }}>( {ttd.nama} )</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{ttd.jabatan}</div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </Modal>

      {/* MODAL DETAIL */}
      <Modal
        show={!!showDetail}
        onClose={()=>setShowDetail(null)}
        title={`Detail PRB — ${showDetail?.no_pr}`}
        footer={<>
          <BtnExportPDF targetRef={detailRef} filename={`PRB-${showDetail?.no_pr}`} />
          <Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>
          {showDetail?.status==='pending' && (user?.divisi==='direktur'||user?.divisi==='proyek') && <>
            <Btn color="merah" onClick={()=>prosesApproval(showDetail.id,'reject')}>❌ Tolak</Btn>
            <Btn color="hijau" onClick={()=>prosesApproval(showDetail.id,'approve')}>✅ Setujui</Btn>
          </>}
        </>}
        >
        {showDetail && (
          <div ref={detailRef} style={{ border:'1px solid #ddd', borderRadius:'4px', overflow:'hidden', fontSize:'12px', background:'white' }}>

          {/* KOP */}
          <KopFormulir
            judulFormulir="Permintaan Pembelian Barang (PPB)"
            rows={[
              ['No. Dok', 'MKMJ/FM/PUR/01-01'],
              ['Revisi', '01'],
              ['Tgl. Terbit', '01 Juni 2026'],
            ]}
          />

            {/* INFO HEADER */}
            <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
              {[
                ['Departemen', showDetail.departemen],
                ['No. PRB',    showDetail.no_pr],
                ['Proyek',     showDetail.nama_proyek],
                ['Tanggal',    showDetail.created_at?.split('T')[0]],
                ['Lokasi',     showDetail.lokasi||'-'],
                ['Tgl Butuh',  showDetail.tgl_butuh?.split('T')[0]||'-'],
              ].map(([l,v])=>(
                <div key={l} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                  <span style={{ fontSize:'12px', fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'100px' }}>{l}</span>
                  <span style={{ fontSize:'12px' }}>:</span>
                  <span style={{ fontSize:'12px', flex:1 }}>{v}</span>
                </div>
              ))}
            </div>

            {/* TABEL ITEM */}
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr style={{ background:'#f0f4f8' }}>
                    {['No.','Nama Barang','Spesifikasi','Jumlah','Satuan','Keterangan','Cek ok/tdk ok'].map((h,i)=>(
                      <th key={i} style={{ padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', whiteSpace:'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(showDetail.items||[]).map((item,idx)=>(
                    <tr key={idx}>
                      <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center', fontWeight:'700', color:'#666' }}>{idx+1}</td>
                      <td style={{ border:'1px solid #ddd', padding:'8px' }}>{item.nama}</td>
                      <td style={{ border:'1px solid #ddd', padding:'8px' }}>{item.spesifikasi||'-'}</td>
                      <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center', fontWeight:'700' }}>{item.jumlah}</td>
                      <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center' }}>{item.satuan}</td>
                      <td style={{ border:'1px solid #ddd', padding:'8px' }}>{item.keterangan||'-'}</td>
                      <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center', fontSize:'14px' }}>
                        {item.cek==='ok'?'✅': item.cek==='tidakOk'?'❌':'—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* KETERANGAN STATUS */}
            <div style={{ padding:'10px 16px', borderTop:'1px solid #ddd', borderBottom:'1px solid #ddd', display:'flex', gap:'20px', alignItems:'center' }}>
              <span style={{ fontSize:'12px', fontWeight:'600' }}>Status:</span>
              <Badge status={showDetail.status} />
            </div>

            {/* TANDA TANGAN */}
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr' }}>
              {[
                { judul:'Diajukan Oleh,',  nama: showDetail.nama_pengaju||'................................', jabatan:'Pengaju' },
                { judul:'Diperiksa Oleh,', nama: '................................', jabatan:'Manajer Proyek' },
                { judul:'Disetujui Oleh,', nama: showDetail.status==='approved' ? (showDetail.nama_penyetuju||'................................') : '................................', jabatan:'Direktur' },
              ].map((ttd,i)=>(
                <div key={i} style={{ padding:'12px 16px', borderRight: i<2?'1px solid #ddd':'none' }}>
                  <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'48px' }}>{ttd.judul}</div>
                  <div style={{ borderTop:'1px solid #333', paddingTop:'4px' }}>
                    <div style={{ fontSize:'11px', color:'#555' }}>( {ttd.nama} )</div>
                    <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{ttd.jabatan}</div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        )}
      </Modal>
    </div>
  );
}

// ============================================
// TAB DPH — Daftar Perbandingan Harga
// ============================================
function TabDPH({ user }) {
  const detailRef = useRef(null); 
  const dataProyekList = useProyekListP();
  const dataMaterialList = useMaterialListP();
  const dataVendorListLive = useVendorListP();
  const { data: listDPH, loading, error, refetch } = useDPH();
  const [showForm, setShowForm]     = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const supplierKosong = { nama:'', harga:'', caraBayar:'', persetujuan:'' };
  const [form, setForm] = useState({
    proyek_id:'', nama_barang:'', spesifikasi:'', vol:'', satuan:'', keterangan:'',
    suppliers:[ {...supplierKosong},{...supplierKosong},{...supplierKosong} ]
  });

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }
  function updateSupplier(idx,field,value) {
    setForm({...form, suppliers: form.suppliers.map((s,i)=>i===idx?{...s,[field]:value}:s)});
  }
  function tambahSupplier() { setForm({...form, suppliers:[...form.suppliers,{...supplierKosong}]}); }
  function hapusSupplier(idx) {
    if (form.suppliers.length<=2){alert('Minimal 2 supplier!');return;}
    setForm({...form, suppliers:form.suppliers.filter((_,i)=>i!==idx)});
  }

  async function submitDPH() {
    if (!form.nama_barang){alert('⚠️ Nama barang wajib diisi!');return;}
    const isi = form.suppliers.filter(s=>s.nama&&s.harga);
    if (isi.length<2){alert('⚠️ Minimal 2 supplier wajib diisi!');return;}
    setSubmitting(true);
    try {
      const result = await pengadaanAPI.createDPH({
        proyek_id:   form.proyek_id ? Number(form.proyek_id) : null,
        nama_barang: form.nama_barang,
        spesifikasi: form.spesifikasi,
        vol:         Number(form.vol||0),
        satuan:      form.satuan,
        keterangan:  form.keterangan,
        suppliers:   isi,
      });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ proyek_id:'', nama_barang:'', spesifikasi:'', vol:'', satuan:'', keterangan:'', suppliers:[{...supplierKosong},{...supplierKosong},{...supplierKosong}] });
        refetch();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  function hargaTerbaik(suppliers) {
    const hargaList = suppliers.map(s=>Number(s.harga||0)).filter(h=>h>0);
    return hargaList.length > 0 ? Math.min(...hargaList) : 0;
  }

  const thS = { padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8', whiteSpace:'nowrap' };
  const tdS = { border:'1px solid #ddd', padding:'6px 10px', fontSize:'12px', verticalAlign:'middle' };
  const inC = { ...inputStyle, padding:'6px 8px', fontSize:'12px', border:'none', background:'transparent', width:'100%' };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
        <span style={{ fontSize:'13px', color:'#666' }}>Total <strong>{listDPH.length}</strong> formulir perbandingan harga</span>
        <Btn onClick={()=>setShowForm(true)}>+ Buat DPH Baru</Btn>
      </div>

      {loading && <LoadingSpinner pesan="Memuat data DPH..." />}
      {error   && <ErrorBox pesan={error} onRetry={refetch} />}

      {!loading && !error && (
        listDPH.length === 0
          ? <EmptyState icon="📊" judul="Belum ada DPH" sub="Klik '+ Buat DPH Baru' untuk membuat perbandingan harga" />
          : (
            <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
              {listDPH.map(dph => {
                const terbaik = hargaTerbaik(dph.suppliers||[]);
                return (
                  <div key={dph.id} style={{ border:'1.5px solid #e0e8f4', borderRadius:'12px', overflow:'hidden' }}>
                    <div style={{ background:'#f8fbff', padding:'12px 16px', display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid #e0e8f4' }}>
                      <div style={{ display:'flex', gap:'16px', alignItems:'center' }}>
                        <strong style={{ color:'#1a3a5c', fontSize:'13px' }}>{dph.no_dph}</strong>
                        <span style={{ fontSize:'13px' }}>📦 {dph.nama_barang}</span>
                        {dph.spesifikasi && <span style={{ fontSize:'12px', color:'#888' }}>{dph.spesifikasi}</span>}
                        <span style={{ fontSize:'12px', color:'#666' }}>Vol: {dph.vol} {dph.satuan}</span>
                        <span style={{ fontSize:'12px', color:'#888' }}>📅 {dph.created_at?.split('T')[0]}</span>
                      </div>
                      <button onClick={()=>setShowDetail(dph)} style={{ padding:'5px 14px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                        Lihat Detail
                      </button>
                    </div>

                    <div style={{ overflowX:'auto' }}>
                      <table style={{ width:'100%', borderCollapse:'collapse' }}>
                        <thead>
                          <tr>{['No.','Supplier / Vendor','Harga Satuan',`Total (${dph.vol} ${dph.satuan})`,'Cara Bayar','Persetujuan'].map(h=>(
                            <th key={h} style={thS}>{h}</th>
                          ))}</tr>
                        </thead>
                        <tbody>
                          {(dph.suppliers||[]).map((s,i)=>{
                            const ok = Number(s.harga)===terbaik && terbaik>0;
                            return (
                              <tr key={i} style={{ background:ok?'#eafaf1':'white' }}>
                                <td style={{ ...tdS, textAlign:'center', fontWeight:'700', color:'#666' }}>{i+1}</td>
                                <td style={{ ...tdS, fontWeight:ok?'700':'400' }}>
                                  {s.nama}
                                  {ok && <span style={{ marginLeft:'6px', fontSize:'10px', background:'#27ae60', color:'white', padding:'2px 6px', borderRadius:'99px' }}>TERBAIK</span>}
                                </td>
                                <td style={{ ...tdS, textAlign:'right', fontWeight:'600', color:ok?'#27ae60':'#333' }}>{formatRp(s.harga)}</td>
                                <td style={{ ...tdS, textAlign:'right', fontWeight:'600' }}>{formatRp(Number(s.harga)*Number(dph.vol||0))}</td>
                                <td style={{ ...tdS, textAlign:'center' }}>{s.cara_bayar||'-'}</td>
                                <td style={{ ...tdS, textAlign:'center', fontSize:'16px' }}>{s.persetujuan||'—'}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <div style={{ padding:'8px 16px', background:'#fafafa', borderTop:'1px solid #e0e8f4', display:'flex', justifyContent:'space-between', fontSize:'11px', color:'#888' }}>
                      <span>Dibuat: <strong>{dph.nama_pembuat}</strong></span>
                      {terbaik > 0 && <span>Harga terbaik: <strong style={{ color:'#27ae60' }}>{formatRp(terbaik)}/satuan</strong></span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )
      )}

      {/* MODAL FORM DPH */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📊 Daftar Perbandingan Harga (DPH)"
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn color="hijau" onClick={submitDPH} disabled={submitting}>{submitting?'⏳ Menyimpan...':'✅ Simpan DPH'}</Btn>
        </>}
      >
        <div style={{ border:'2px solid #1a3a5c', borderRadius:'5px', overflow:'auto', fontSize:'12px' }}>
          <KopFormulir
            judulFormulir="Daftar Perbandingan Harga"
            rows={[
              ['No. Dok', 'MKMJ/FM/PUR/01-03'],
              ['Revisi', '01'],
              ['Tgl. Terbit', '01 Juni 2026'],
            ]}
          />

          <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontSize:'12px', fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'90px' }}>Nama Barang</span>
              <span>:</span>
              <div style={{ flex:1 }}>
                <SelectMaterial
                  value={form.nama_barang}
                  onChange={(val)=>setForm(prev=>({ ...prev, nama_barang: val }))}
                  onPilihItem={(item)=>setForm(prev=>({ ...prev, satuan: item.satuan || prev.satuan }))}
                  list={dataMaterialList}
                />
              </div>
            </div>

            {[
              {label:'Spesifikasi', name:'spesifikasi', ph:'Tipe, mutu, ukuran...'},
              {label:'Volume',      name:'vol',         ph:'0', type:'number'      },
              {label:'Satuan',      name:'satuan',       ph:'M³, sak, btg...'      },
            ].map(f=>(
              <div key={f.name} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                <span style={{ fontSize:'12px', fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'90px' }}>{f.label}</span>
                <span>:</span>
                <input name={f.name} value={form[f.name]} onChange={handleChange}
                  type={f.type||'text'} placeholder={f.ph}
                  style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px', flex:1 }} />
              </div>
            ))}
            <div style={{ display:'flex', alignItems:'center', gap:'6px', gridColumn:'1/-1' }}>
              <span style={{ fontSize:'12px', fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'90px' }}>Proyek</span>
              <span>:</span>
              <div style={{ flex:1 }}>
                <SelectProyek
                  value={form.proyek_id}
                  onChange={(val)=>setForm({...form, proyek_id: val})}
                  list={dataProyekList}
                  placeholder="-- Pilih Proyek (opsional) --"
                />
              </div>
            </div>
          </div>

          <div style={{ overflowX:'auto', overflowY:'auto', maxHeight:'240px' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:'520px' }}>
              <thead style={{ position:'sticky', top:0, zIndex:1 }}>
                <tr>
                  {['No.','Supplier / Vendor','Harga Satuan (Rp)','Cara Pembayaran','Persetujuan',''].map(h=>(
                    <th key={h} style={{ ...thS, background:'#f0f4f8' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {form.suppliers.map((s,idx)=>{
                  const hargaList = form.suppliers.map(x=>Number(x.harga||0)).filter(h=>h>0);
                  const min = hargaList.length>0 ? Math.min(...hargaList) : 0;
                  const ok  = Number(s.harga)>0 && Number(s.harga)===min;
                  return (
                    <tr key={idx} style={{ background:ok?'#f0fff4':'white' }}>
                      <td style={{ ...tdS, textAlign:'center', fontWeight:'700', color:'#666', width:'32px' }}>{idx+1}</td>
                      <td style={{ ...tdS, padding:'4px' }}>
                        <SelectSupplier
                          value={s.nama}
                          onChange={(val)=>updateSupplier(idx,'nama',val)}
                          list={dataVendorListLive}
                        />
                      </td>
                      <td style={{ ...tdS, padding:'4px', width:'140px' }}>
                        <input type="number" value={s.harga} onChange={e=>updateSupplier(idx,'harga',e.target.value)}
                          placeholder="0" style={{ ...inC, textAlign:'right', color:ok?'#27ae60':'#333', fontWeight:ok?'700':'400' }} />
                      </td>
                      <td style={{ ...tdS, padding:'4px', width:'130px' }}>
                        <select value={s.caraBayar} onChange={e=>updateSupplier(idx,'caraBayar',e.target.value)} style={{ ...inC, cursor:'pointer' }}>
                          <option value="">— Pilih —</option>
                          <option value="Cash">💵 Cash</option>
                          <option value="Tempo 7 hari">⏱️ Tempo 7 hari</option>
                          <option value="Tempo 14 hari">⏱️ Tempo 14 hari</option>
                          <option value="Tempo 30 hari">⏱️ Tempo 30 hari</option>
                          <option value="Transfer">🏦 Transfer</option>
                        </select>
                      </td>
                      <td style={{ ...tdS, padding:'4px', width:'110px', textAlign:'center' }}>
                        <select value={s.persetujuan} onChange={e=>updateSupplier(idx,'persetujuan',e.target.value)}
                          style={{ ...inC, fontWeight:'600', textAlign:'center', cursor:'pointer',
                            color:s.persetujuan==='✅'?'#27ae60':s.persetujuan==='❌'?'#e74c3c':'#888'
                          }}>
                          <option value="">— Pilih —</option>
                          <option value="✅">✅ Disetujui</option>
                          <option value="❌">❌ Ditolak</option>
                        </select>
                      </td>
                      <td style={{ ...tdS, width:'32px', textAlign:'center' }}>
                        <button onClick={()=>hapusSupplier(idx)} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'14px', opacity:0.4 }}>🗑️</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div style={{ padding:'8px 12px', borderTop:'1px solid #ddd', background:'#fafcff', borderBottom:'1px solid #ddd' }}>
            <button onClick={tambahSupplier} style={{ padding:'5px 14px', background:'white', border:'1.5px dashed #2d6a9f', borderRadius:'6px', fontSize:'12px', color:'#2d6a9f', cursor:'pointer', fontWeight:'600' }}>
              + Tambah Supplier
            </button>
          </div>

          <div style={{ padding:'10px 16px', borderBottom:'1px solid #ddd' }}>
            <label style={{ fontSize:'12px', fontWeight:'600', color:'#444', display:'block', marginBottom:'6px' }}>Keterangan / Rekomendasi:</label>
            <textarea name="keterangan" value={form.keterangan} onChange={handleChange}
              rows="2" placeholder="Catatan perbandingan, rekomendasi supplier terpilih..."
              style={{ ...inputStyle, resize:'vertical', fontSize:'12px' }} />
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr' }}>
            {[
              { judul:'Dibuat oleh,',  nama: user?.nama||'................................', jab:'Purchasing Staff' },
              { judul:'Disetujui,',    nama:'................................',               jab:'Direktur'    },
            ].map((t,i)=>(
              <div key={i} style={{ padding:'12px 20px', borderRight:i<1?'1px solid #ddd':'none' }}>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'44px' }}>{t.judul}</div>
                <div style={{ borderTop:'1px solid #333', paddingTop:'4px' }}>
                  <div style={{ fontSize:'11px', color:'#555' }}>( {t.nama} )</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{t.jab}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>

      {/* MODAL DETAIL */}
        <Modal show={!!showDetail} onClose={()=>setShowDetail(null)} title={`Detail DPH — ${showDetail?.no_dph}`}
          footer={<>
            <BtnExportPDF targetRef={detailRef} filename={`DPH-${showDetail?.no_dph}`} />
            <Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>
          </>}
          >
          {showDetail && (
            <div ref={detailRef} style={{ fontSize:'12px', background:'white' }}>

              <KopFormulir
                judulFormulir="Daftar Perbandingan Harga (DPH)"
                rows={[
                  ['No. Dok',    'MKMJ/FM/PUR/01-03'],
                  ['Revisi',     '01'],
                  ['Tgl. Terbit','01 Juni 2026'],
                ]}
              />

              {/* INFO HEADER */}
              <div style={{ padding:'12px 16px', border:'1.5px solid #000', borderTop:'none', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
                {[
                  ['No. DPH',     showDetail.no_dph],
                  ['Tanggal',     showDetail.created_at?.split('T')[0]],
                  ['Nama Barang', showDetail.nama_barang],
                  ['Spesifikasi', showDetail.spesifikasi||'-'],
                  ['Volume',      `${showDetail.vol} ${showDetail.satuan}`],
                  ['Dibuat oleh', showDetail.nama_pembuat],
                ].map(([l,v])=>(
                  <div key={l} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                    <span style={{ fontSize:'12px', fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'90px' }}>{l}</span>
                    <span style={{ fontSize:'12px' }}>:</span>
                    <span style={{ fontSize:'12px', flex:1 }}>{v||'-'}</span>
                  </div>
                ))}
              </div>

              {/* TABEL SUPPLIER */}
              <div style={{ overflowX:'auto', border:'1.5px solid #000', borderTop:'none' }}>
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead>
                    <tr style={{ background:'#f0f4f8' }}>
                      {['No.','Supplier','Harga Satuan','Total','Cara Bayar','Persetujuan'].map(h=>(
                        <th key={h} style={{ padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {(showDetail.suppliers||[]).map((s,i)=>{
                      const best = hargaTerbaik(showDetail.suppliers);
                      const ok   = Number(s.harga)===best && best>0;
                      return (
                        <tr key={i} style={{ background:ok?'#eafaf1':'white' }}>
                          <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center', fontWeight:'700', color:'#666' }}>{i+1}</td>
                          <td style={{ border:'1px solid #ddd', padding:'8px', fontWeight:ok?'700':'400' }}>
                            {s.nama}{ok&&<span style={{ marginLeft:'6px', fontSize:'10px', background:'#27ae60', color:'white', padding:'2px 6px', borderRadius:'99px' }}>TERBAIK</span>}
                          </td>
                          <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'right', fontWeight:'600', color:ok?'#27ae60':'#333' }}>{formatRp(s.harga)}</td>
                          <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'right' }}>{formatRp(Number(s.harga)*Number(showDetail.vol||0))}</td>
                          <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center' }}>{s.cara_bayar||'-'}</td>
                          <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center', fontSize:'16px' }}>{s.persetujuan||'—'}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* KETERANGAN */}
              <div style={{ padding:'10px 16px', border:'1.5px solid #000', borderTop:'none', fontSize:'12px', color:'#555' }}>
                <strong>Keterangan:</strong> {showDetail.keterangan || '-'}
              </div>

              {/* TANDA TANGAN */}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', border:'1.5px solid #000', borderTop:'none' }}>
                {[
                  { judul:'Dibuat oleh,',  nama: showDetail.nama_pembuat||'................................', jabatan:'Purchasing Staff' },
                  { judul:'Disetujui,',    nama:'................................', jabatan:'Direktur' },
                ].map((ttd,i)=>(
                  <div key={i} style={{ padding:'12px 20px', borderRight: i<1?'1.5px solid #000':'none' }}>
                    <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'44px' }}>{ttd.judul}</div>
                    <div style={{ borderTop:'1px solid #333', paddingTop:'4px' }}>
                      <div style={{ fontSize:'11px', color:'#555' }}>( {ttd.nama} )</div>
                      <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{ttd.jabatan}</div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          )}
        </Modal>
    </div>
  );
}

// ============================================
// TAB PO — Surat Pesanan Barang (SPB)
// ============================================
function TabPO({ user }) {
  const detailRef = useRef(null);
  const dataProyekList = useProyekListP();
  const dataMaterialList = useMaterialListP();
  const dataVendorListLive = useVendorListP();
  const [filter, setFilter]         = useState('');
  const { data: listPO, loading, error, refetch } = usePO(filter);
  const [showForm, setShowForm]     = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const itemKosong = { nama:'', spesifikasi:'', satuan:'', jumlah:'', hargaSatuan:'', ket:'' };
  const [form, setForm] = useState({
    proyek_id:'', namaSupplier:'', alamatSupplier:'', upNama:'',
    caraBayar:'tunai', tempoHari:'', lokasi:'', penerima:'',
    harisTerkirim:'', catatan:'', items:[{...itemKosong}]
  });

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }
  function updateItem(idx,field,value) {
    setForm(prev => ({ ...prev, items: prev.items.map((it,i)=>i===idx?{...it,[field]:value}:it) }));
  }
  function tambahItem() { setForm({...form, items:[...form.items,{...itemKosong}]}); }
  function hapusItem(idx) { setForm({...form, items:form.items.filter((_,i)=>i!==idx)}); }

  function subtotal(item) { return Number(item.jumlah||0)*Number(item.hargaSatuan||0); }
  function totalSemua(items) { return items.reduce((s,it)=>s+subtotal(it),0); }

  async function submitPO(status) {
    if (!form.namaSupplier||!form.proyek_id){alert('⚠️ Supplier dan proyek wajib diisi!');return;}
    if (!form.items[0].nama){alert('⚠️ Minimal 1 item bahan wajib diisi!');return;}
    setSubmitting(true);
    try {
      const result = await pengadaanAPI.createPO({
        proyek_id:       Number(form.proyek_id),
        nama_supplier:   form.namaSupplier,
        alamat_supplier: form.alamatSupplier,
        up_nama:         form.upNama,
        cara_bayar:      form.caraBayar,
        tempo_hari:      form.tempoHari ? Number(form.tempoHari) : null,
        lokasi:          form.lokasi,
        penerima:        form.penerima,
        harus_terkirim:  form.harisTerkirim||null,
        catatan:         form.catatan,
        items:           form.items.filter(i=>i.nama).map(i=>({
          nama:         i.nama,
          spesifikasi:  i.spesifikasi,
          satuan:       i.satuan,
          jumlah:       Number(i.jumlah||0),
          harga_satuan: Number(i.hargaSatuan||0),
          ket:          i.ket,
        })),
      });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ proyek_id:'', namaSupplier:'', alamatSupplier:'', upNama:'', caraBayar:'tunai', tempoHari:'', lokasi:'', penerima:'', harisTerkirim:'', catatan:'', items:[{...itemKosong}] });
        refetch();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function prosesApproval(id, aksi) {
    if (!window.confirm(`${aksi==='approve'?'✅ Setujui':'❌ Tolak'} SPB ini?`)) return;
    try {
      const result = await pengadaanAPI.approvePO(id, aksi);
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowDetail(null);
        refetch();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
  }

  const thS = { padding:'7px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8', whiteSpace:'nowrap' };
  const tdS = { border:'1px solid #ddd', padding:'5px 8px', fontSize:'12px', verticalAlign:'middle' };
  const inC = { ...inputStyle, padding:'5px 7px', fontSize:'12px', border:'none', background:'transparent', width:'100%' };
  // Style tabel item khusus tampilan detail (read-only) — font/padding lebih kecil + word-wrap agar muat tanpa scroll horizontal
  const thSd = { padding:'6px 5px', fontSize:'10.5px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8', whiteSpace:'normal', wordBreak:'break-word' };
  const tdSd = { border:'1px solid #ddd', padding:'6px 6px', fontSize:'11px', verticalAlign:'middle', whiteSpace:'normal', wordBreak:'break-word' };

  // Render SPB dokumen
  function renderSPB(data, isForm=false) {
    const items = isForm ? form.items : (data.items||[]);
    const total = totalSemua(items);
    const tglFmt = (t) => t ? new Date(t).toLocaleDateString('id-ID',{day:'numeric',month:'long',year:'numeric'}) : '................';

    return (
      <div className="spb-doc" style={{ border:'2px solid #1a3a5c', borderRadius:'8px', overflow:'auto', fontSize:'12px' }}>
        <KopFormulir
          judulFormulir="Surat Pesanan Barang (SPB)"
          rows={[
            ['No. Dok', 'MKMJ/FM/PUR/01-04'],
            ['Revisi', '01'],
            ['Tgl. Terbit', '01 Juni 2026'],
          ]}
        />

        <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }} className="spb-grid">
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <div className="spb-row" style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Nama Supplier</span>
              <span>:</span>
              {isForm ? (
                <div style={{ flex:1 }}>
                  <SelectSupplier
                    value={form.namaSupplier}
                    onChange={(val)=>setForm(prev=>({ ...prev, namaSupplier: val }))}
                    list={dataVendorListLive}
                  />
                </div>
              ) : (
                <span style={{ flex:1 }}>{data.nama_supplier || '—'}</span>
              )}
            </div>

            {[
              {label:'Alamat', name:'alamatSupplier', ph:'Jl. ......................'},
              {label:'U.P.',   name:'upNama',          ph:'Nama kontak person'   },
            ].map(f=>(
              <div key={f.name} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>{f.label}</span>
                <span>:</span>
                {isForm
                  ? <input name={f.name} value={form[f.name]} onChange={handleChange} placeholder={f.ph} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
                  : <span style={{ flex:1 }}>{data[f.name.replace(/[A-Z]/g,m=>'_'+m.toLowerCase())]||'—'}</span>
                }
              </div>
            ))}
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <div className="spb-row" style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'120px' }}>No. SPB</span>
              <span>:</span>
              <span style={{ fontWeight:'700', color:'#1a3a5c' }}>{isForm?'(otomatis)':data.no_spb}</span>
            </div>
            <div className="spb-row" style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'120px' }}>Proyek</span>
              <span>:</span>
              {isForm
                ? <div style={{ flex:1 }}><SelectProyek value={form.proyek_id} onChange={(val)=>setForm({...form, proyek_id: val})} list={dataProyekList} /></div>
                : <span>{data.nama_proyek||'—'}</span>
              }
            </div>
            <div className="spb-row" style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'120px' }}>Cara Pembayaran</span>
              <span>:</span>
              {isForm
                ? <div style={{ display:'flex', gap:'10px', alignItems:'center', flex:1 }}>
                    <label style={{ display:'flex', alignItems:'center', gap:'4px', cursor:'pointer' }}>
                      <input type="radio" name="caraBayar" value="tunai" checked={form.caraBayar==='tunai'} onChange={handleChange} /> Tunai
                    </label>
                    <label style={{ display:'flex', alignItems:'center', gap:'4px', cursor:'pointer' }}>
                      <input type="radio" name="caraBayar" value="kredit" checked={form.caraBayar==='kredit'} onChange={handleChange} /> Kredit
                    </label>
                    {form.caraBayar==='kredit' && <input name="tempoHari" value={form.tempoHari} onChange={handleChange} placeholder="hari" style={{ ...inputStyle, padding:'4px 8px', fontSize:'12px', width:'60px' }} />}
                  </div>
                : <span>{data.cara_bayar==='tunai'?'☑ Tunai':`☑ Kredit ${data.tempo_hari||''} hari`}</span>
              }
            </div>

            {/* APPROVAL STATUS — 2 level, disembunyikan saat export PDF */}
            {!isForm && (
              <div className="no-export" style={{ marginTop:'4px', padding:'8px', background:'#f8fbff', borderRadius:'8px', border:'1px solid #e0e8f4' }}>
                <p style={{ fontSize:'11px', fontWeight:'700', color:'#1a3a5c', margin:'0 0 6px' }}>Status Approval</p>
                <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                  <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px' }}>
                    <div style={{ width:'28px', height:'28px', borderRadius:'50%', background: data.status==='approved'||data.status==='menunggu'?'#27ae60':'#ddd', color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'700', fontSize:'12px' }}>1</div>
                    <span style={{ fontSize:'10px', fontWeight:'600' }}>Logistik</span>
                    <span style={{ fontSize:'10px', color:'#27ae60' }}>Pembuat</span>
                  </div>
                  <div style={{ height:'2px', background:'#ddd', flex:1 }} />
                  <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px' }}>
                    <div style={{ width:'28px', height:'28px', borderRadius:'50%', background: data.status==='approved'?'#27ae60': data.status==='rejected'?'#e74c3c':'#ddd', color: data.status==='menunggu'?'#888':'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'700', fontSize:'12px' }}>2</div>
                    <span style={{ fontSize:'10px', fontWeight:'600' }}>Direktur</span>
                    <span style={{ fontSize:'10px', color: data.status==='approved'?'#27ae60': data.status==='rejected'?'#e74c3c':'#aaa' }}>
                      {data.status==='approved'?'Disetujui': data.status==='rejected'?'Ditolak':'Menunggu'}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={{ padding:'10px 16px', borderBottom:'1px solid #ddd', fontSize:'12px', color:'#333', fontStyle:'italic' }}>
          Bahwa sesuai dengan penawaran dan spesifikasi yang telah disepakati, maka kami menyetujui untuk memesan bahan sebagai berikut :
        </div>

        <div className={isForm?'spb-items-wrap':''} style={{ overflowX:'auto', overflowY:isForm?'auto':'visible', maxHeight:isForm?'240px':'none' }}>
          <table className={isForm?'spb-form-table':'spb-view-table'} style={{ width:'100%', borderCollapse:'collapse', minWidth: isForm?'580px':'640px', tableLayout: isForm?'auto':'fixed' }}>
            {!isForm && (
              <colgroup>
                <col style={{ width:'5%' }} />
                <col style={{ width:'19%' }} />
                <col style={{ width:'21%' }} />
                <col style={{ width:'7%' }} />
                <col style={{ width:'7%' }} />
                <col style={{ width:'14%' }} />
                <col style={{ width:'15%' }} />
                <col style={{ width:'12%' }} />
              </colgroup>
            )}
            <thead style={{ position:isForm?'sticky':'static', top:0, zIndex:1 }}>
              <tr>
                <th style={isForm?thS:thSd}>No.</th>
                <th style={isForm?thS:thSd}>Nama Bahan</th>
                <th style={isForm?thS:thSd}>Spesifikasi</th>
                <th style={isForm?thS:thSd}>Satuan</th>
                <th style={isForm?thS:thSd}>Jumlah</th>
                <th style={isForm?{...thS, whiteSpace:'normal', wordBreak:'break-word', maxWidth:'85px'}:thSd}>Harga Satuan (Rp)</th>
                <th style={isForm?{...thS, whiteSpace:'normal', wordBreak:'break-word', maxWidth:'85px'}:thSd}>Jumlah Harga (Rp)</th>
                <th style={isForm?thS:thSd}>Ket.</th>
                {isForm && <th style={thS}></th>}
              </tr>
            </thead>
            <tbody>
              {items.map((item,idx)=>(
                <tr key={idx}>
                  <td data-label="No." style={{ ...(isForm?tdS:tdSd), textAlign:'center', fontWeight:'700', color:'#666', width:isForm?'32px':undefined }}>{idx+1}</td>
                  <td data-label="Nama Bahan" style={{ ...(isForm?tdS:tdSd), padding:isForm?'3px':tdSd.padding }}>
                    {isForm ? (
                      <SelectMaterial
                        value={item.nama}
                        onChange={(nilai)=>updateItem(idx,'nama',nilai)}
                        onPilihItem={(m)=>updateItem(idx,'satuan', m.satuan || item.satuan)}
                        list={dataMaterialList}
                      />
                    ) : item.nama}
                  </td>
                  <td data-label="Spesifikasi" style={{ ...(isForm?tdS:tdSd), padding:isForm?'3px':tdSd.padding }}>{isForm?<input value={item.spesifikasi} onChange={e=>updateItem(idx,'spesifikasi',e.target.value)} placeholder="Spesifikasi" style={inC}/>:item.spesifikasi}</td>
                  <td data-label="Satuan" style={{ ...(isForm?tdS:tdSd), width:isForm?'70px':undefined, padding:isForm?'3px':tdSd.padding, textAlign:'center' }}>{isForm?<input value={item.satuan} onChange={e=>updateItem(idx,'satuan',e.target.value)} placeholder="m³" style={{ ...inC, textAlign:'center' }}/>:item.satuan}</td>
                  <td data-label="Jumlah" style={{ ...(isForm?tdS:tdSd), width:isForm?'70px':undefined, textAlign:isForm?'center':'right' }}>{isForm?<input type="number" value={item.jumlah} onChange={e=>updateItem(idx,'jumlah',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'center' }}/>:item.jumlah}</td>
                  <td data-label="Harga Satuan (Rp)" style={{ ...(isForm?tdS:tdSd), width:isForm?'95px':undefined, textAlign:'right' }}>{isForm?<input type="number" value={item.hargaSatuan} onChange={e=>updateItem(idx,'hargaSatuan',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'right' }}/>:formatRp(item.harga_satuan)}</td>
                  <td data-label="Jumlah Harga (Rp)" style={{ ...(isForm?tdS:tdSd), width:isForm?'95px':undefined, textAlign:'right', fontWeight:'600', color:'#1a3a5c', background:'#f8fbff' }}>{formatRp(isForm?subtotal(item):Number(item.jumlah_harga||0))}</td>
                  <td data-label="Ket." style={{ ...(isForm?tdS:tdSd), padding:isForm?'3px':tdSd.padding }}>{isForm?<input value={item.ket} onChange={e=>updateItem(idx,'ket',e.target.value)} placeholder="Ket" style={inC}/>:item.ket}</td>
                  {isForm && <td data-label="" className="c-hapus" style={{ ...tdS, width:'32px', textAlign:'center' }}>{items.length>1&&<button onClick={()=>hapusItem(idx)} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'14px', opacity:0.4 }}>🗑️</button>}</td>}
                </tr>
              ))}
              <tr className="spb-total-row" style={{ background:'#f0f4f8' }}>
                <td className="c-total-label" colSpan={isForm?6:5} style={{ ...(isForm?tdS:tdSd), textAlign:'center', fontWeight:'700', letterSpacing:'2px', color:'#1a3a5c' }}>J U M L A H</td>
                <td style={{ ...(isForm?tdS:tdSd), textAlign:'right', fontWeight:'700', fontSize:isForm?'13px':'12px', color:'#1a3a5c' }}>{formatRp(isForm?total:items.reduce((s,i)=>s+Number(i.jumlah_harga||0),0))}</td>
                <td style={isForm?tdS:tdSd}></td>
                {isForm && <td style={tdS}></td>}
              </tr>
            </tbody>
          </table>
        </div>

        {isForm && (
          <div style={{ padding:'8px 12px', borderTop:'1px solid #ddd', background:'#fafcff', borderBottom:'1px solid #ddd' }}>
            <button onClick={tambahItem} style={{ padding:'5px 14px', background:'white', border:'1.5px dashed #2d6a9f', borderRadius:'6px', fontSize:'12px', color:'#2d6a9f', cursor:'pointer', fontWeight:'600' }}>
              + Tambah Item
            </button>
          </div>
        )}

        <div style={{ padding:'12px 16px', borderTop:'1px solid #ddd', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }} className="spb-grid">
          {[
            {label:'Mohon dikirim ke', name:'alamatSupplier', ph:'Alamat pengiriman'},
            {label:'Lokasi',           name:'lokasi',         ph:'Lokasi proyek'   },
            {label:'Penerima',         name:'penerima',       ph:'Nama penerima'   },
            {label:'Harus terkirim tgl', name:'harisTerkirim', ph:'', type:'date'  },
          ].map(f=>(
            <div key={f.name} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'700', color:'#444', whiteSpace:'nowrap', minWidth:'130px', fontSize:'12px' }}>{f.label}</span>
              <span>:</span>
              {isForm
                ? f.type==='date'
                  ? <input type="date" name={f.name} value={form[f.name]} onChange={handleChange} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
                  : <input name={f.name} value={form[f.name]} onChange={handleChange} placeholder={f.ph} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
                : <span style={{ fontSize:'12px' }}>{f.name==='harisTerkirim' ? tglFmt(data.harus_terkirim) : (data[f.name.replace(/[A-Z]/g,m=>'_'+m.toLowerCase())]||'—')}</span>
              }
            </div>
          ))}
        </div>

        <div style={{ padding:'12px 24px', display:'flex', justifyContent:'flex-end' }}>
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:'12px', marginBottom:'48px' }}>
              Surabaya, {new Date().toLocaleDateString('id-ID',{day:'numeric',month:'long',year:'numeric'})}
            </div>
            <div style={{ fontWeight:'700', fontSize:'12px', marginBottom:'4px' }}>PT MITRA KARYA MANDIRI JAYA</div>
            <div style={{ marginBottom:'48px' }}>&nbsp;</div>
            <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px', margin:'0 auto' }}>
              <div style={{ fontSize:'11px', color:'#555' }}>( {isForm ? user?.nama||'................................' : data.nama_logistik||'................................'} )</div>
              <div style={{ fontSize:'11px', color:'#888', marginTop:'2px', fontWeight:'600', letterSpacing:'1px' }}>LOGISTIK</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const filtered = filter ? listPO.filter(p=>p.status===filter) : listPO;

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px', gap:'10px' }}>
        <select value={filter} onChange={e=>setFilter(e.target.value)} style={{ ...inputStyle, maxWidth:'220px' }}>
          <option value="">Semua Status</option>
          <option value="menunggu">Menunggu Approval</option>
          <option value="approved">Disetujui</option>
          <option value="rejected">Ditolak</option>
          <option value="draft">Draft</option>
        </select>
        <Btn onClick={()=>setShowForm(true)}>+ Buat SPB Baru</Btn>
      </div>

      {loading && <LoadingSpinner pesan="Memuat data SPB dari database..." />}
      {error   && <ErrorBox pesan={error} onRetry={refetch} />}

      {!loading && !error && (
        filtered.length === 0
          ? <EmptyState icon="🛒" judul="Belum ada SPB" sub="Klik '+ Buat SPB Baru' untuk membuat surat pesanan" />
          : (
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                    {['No. SPB','Tgl','Supplier','Proyek','Item','Nilai','Approval Direktur','Status','Aksi'].map(h=>(
                      <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'8px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(po=>(
                    <tr key={po.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                      <td style={{ padding:'12px', fontSize:'13px' }}><strong>{po.no_spb}</strong></td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{po.created_at?.split('T')[0]}</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{po.nama_supplier}</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{po.nama_proyek}</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>
                        {(po.items||[]).length > 0
                          ? <div style={{ display:'flex', flexDirection:'column', gap:'3px' }}>
                              {po.items.slice(0,2).map((it,i)=>(
                                <div key={i} style={{ fontSize:'11px' }}>
                                  <span style={{ background:'#eaf0fb', color:'#2d6a9f', padding:'1px 5px', borderRadius:'4px', marginRight:'4px', fontWeight:'700' }}>{i+1}</span>
                                  {it.nama} — {it.jumlah} {it.satuan}
                                </div>
                              ))}
                              {po.items.length > 2 && <span style={{ fontSize:'11px', color:'#aaa' }}>+{po.items.length-2} item lagi</span>}
                            </div>
                          : <span style={{ color:'#aaa' }}>{po.material||'-'}</span>
                        }
                      </td>
                      <td style={{ padding:'12px', fontSize:'13px', fontWeight:'600' }}>{formatRp(po.total_nilai)}</td>
                      <td style={{ padding:'12px', fontSize:'12px', textAlign:'center' }}>
                        {po.approval_direktur==='approved' ? '✅ Disetujui' : po.approval_direktur==='rejected' ? '❌ Ditolak' : '⏳ Menunggu'}
                      </td>
                      <td style={{ padding:'12px' }}><Badge status={po.status} /></td>
                      <td style={{ padding:'12px' }}>
                        <button onClick={()=>setShowDetail(po)} style={{ padding:'5px 12px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                          Lihat SPB
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
      )}

      {/* MODAL FORM SPB */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📋 Buat Surat Pesanan Barang (SPB)" width="min(820px, 95vw)"
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn onClick={()=>submitPO('menunggu')} disabled={submitting}>{submitting?'⏳ Menyimpan...':'📤 Submit ke Direktur'}</Btn>
        </>}
      >
        {renderSPB(null, true)}
      </Modal>

      {/* MODAL DETAIL SPB */}
      <Modal show={!!showDetail} onClose={()=>setShowDetail(null)} title={`Surat Pesanan Barang — ${showDetail?.no_spb}`} width="min(820px, 94vw)"
        footer={<>
          <BtnExportPDF targetRef={detailRef} filename={`PRB-${showDetail?.no_pr}`} />
          <Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>
          {showDetail?.status==='menunggu' && user?.divisi==='direktur' && <>
            <Btn color="merah" onClick={()=>prosesApproval(showDetail.id,'reject')}>❌ Tolak SPB</Btn>
            <Btn color="hijau" onClick={()=>prosesApproval(showDetail.id,'approve')}>✅ Setujui SPB</Btn>
          </>}
        </>}
      >
        {showDetail && <div ref={detailRef}>{renderSPB(showDetail, false)}</div>}
      </Modal>
    </div>
  );
}

// ============================================
// KOMPONEN UTAMA
// ============================================
function Pengadaan({ user }) {
  const [tabAktif, setTabAktif] = useState('pr');

  const tabs = [
  { id:'pr',  label:'📋 Permintaan Pembelian'   },
  { id:'dph', label:'📊 Perbandingan Harga'      },
  { id:'po',  label:'🛒 Purchase Order'          },
  
];


  return (
    <div style={{ display:'flex', flexDirection:'column' }}>
      <header style={{ display:'flex', justifyContent:'space-between', alignItems:'center', background:'white', padding:'14px 24px', borderBottom:'1px solid #e8edf2', position:'sticky', top:0, zIndex:10 }}>
        <div>
          <h1 style={{ fontSize:'18px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>Pengadaan</h1>
          <span style={{ fontSize:'12px', color:'#888' }}>Manajemen PPB · PO · Penerimaan Barang</span>
        </div>
        <div style={{ fontSize:'13px', color:'#666' }}>👤 {user?.nama} — {user?.role}</div>
      </header>

      <div style={{ padding:'24px', display:'flex', flexDirection:'column', gap:'20px' }}>

        {/* TAB BAR */}
        <div style={{ display:'flex', gap:'8px', background:'white', padding:'8px', borderRadius:'12px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          {tabs.map(t=>(
            <button key={t.id} onClick={()=>setTabAktif(t.id)} style={{
              padding:'10px 20px', border:'none', borderRadius:'8px',
              fontSize:'13px', fontWeight:'600', cursor:'pointer',
              background: tabAktif===t.id?'#1a3a5c':'transparent',
              color: tabAktif===t.id?'white':'#888',
            }}>
              {t.label}
            </button>
          ))}
        </div>

        {/* KONTEN */}
        <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', marginBottom:'16px', marginTop:0 }}>
            {tabs.find(t=>t.id===tabAktif)?.label}
          </h3>
          {tabAktif==='pr' && <TabPR user={user} />}
          {tabAktif==='dph' && <TabDPH user={user} />}
          {tabAktif==='po' && <TabPO user={user} />}
        </div>

      </div>
    </div>
  );
}

export default Pengadaan;